import { getTierImage } from '..';
import './styles.scss';
export const getTierConfig = (tier: string) => {
  switch (tier) {
    case 'Great White':
      return {
        emoji: '🦈',
        image: getTierImage(tier),
        name: 'Great White',
        gradient: 'from-cyan-400 via-blue-500 to-purple-600',
        glow: 'shadow-cyan-400/80',
        border: 'border-cyan-400',
      };
    case 'Whale Shark':
      return {
        emoji: '🐋',
        name: 'Whale Shark',
        image: getTierImage(tier),
        gradient: 'from-purple-400 via-pink-500 to-purple-600',
        glow: 'shadow-purple-400/80',
        border: 'border-purple-400',
      };
    case 'Hammerhead':
      return {
        emoji: '🐬',
        name: 'Hammerhead',
        image: getTierImage(tier),
        gradient: 'from-blue-400 via-cyan-500 to-teal-500',
        glow: 'shadow-blue-400/80',
        border: 'border-blue-400',
      };
    case 'Swordfish':
      return {
        emoji: '🦈',
        name: 'Swordfish',
        image: getTierImage(tier),
        gradient: 'from-slate-400 via-[#d0aa50] to-[#ffea35]',
        glow: 'shadow-slate-400/80',
        border: 'border-[#a0aa56]',
      };
    case 'Clownfish':
      return {
        emoji: '🐟',
        name: 'Clownfish',
        image: getTierImage(tier),
        gradient: 'from-emerald-400 via-teal-500 to-cyan-500',
        glow: 'shadow-emerald-400/80',
        border: 'border-emerald-400',
      };

    default:
      return {
        emoji: '🐟',
        name: 'Shrimp',
        image: getTierImage(tier),
        gradient: 'from-[#ba994f] via-[#f39274] to-[#e35c32]',
        glow: 'shadow-[#c7732b]',
        border: 'border-[#c7732b]',
      };
  }
};

const TierBadge = ({ tier }: { tier: string }) => {
  const config = getTierConfig(tier);

  return (
    <div className="group relative flex items-center justify-start">
      {/* Main badge container */}
      <div
        className={`relative flex min-w-[125px] flex-col items-center justify-start rounded-xl bg-[white] dark:bg-slate-800/90 backdrop-blur-sm ${config.glow} shadow-xl group-hover:scale-105 transition-all duration-500`}
        style={{
          animation: 'swim 3s ease-in-out infinite',
        }}
      >
        <div
          className="text-4xl transition-transform duration-500 group-hover:scale-110"
          style={{
            animation: 'float 2s ease-in-out infinite',
          }}
        >
          <img className="w-[30px] h-[30px]" src={config.image} />
        </div>

        <div className="absolute inset-0 pointer-events-none">
          {Array.from({ length: 4 }, (_, i) => (
            <div
              key={i}
              className={`absolute w-1.5 h-1.5 bg-gradient-to-r ${config.gradient} rounded-full opacity-60`}
              style={{
                left: `${25 + 50 * Math.cos((i * 90 * Math.PI) / 180)}%`,
                top: `${50 + 50 * Math.sin((i * 90 * Math.PI) / 180)}%`,
                animation: `orbit 4s linear infinite`,
                animationDelay: `${i * 1}s`,
              }}
            />
          ))}
        </div>
        {/* Tier name below the badge */}
        <div
          className={`text-xs font-mono font-semibold tracking-wider bg-gradient-to-r ${config.gradient} bg-clip-text text-transparent`}
        >
          {config.name.toUpperCase()}
        </div>
      </div>
    </div>
  );
};

export default TierBadge;
